<div style="text-align:center">
    <button class="btn btn-primary btn-lg" *ngIf="!isRecording" (click)="startVideoRecording()">Start Recording</button>

    <video class="video" #video autoplay controls></video>
    <span class="m-1"></span>
    <button class="btn btn-primary btn-lg" *ngIf="!isRecording" (click)="startRecording()">Start Recording</button>
    <button class="btn btn-warning btn-lg" *ngIf="isRecording" (click)="stopRecording()">Stop Recording</button>
    <ng-container *ngIf="downloadUrl">
        <video class="video" style="width:360 !important;" controls #recordedVideo  [src]="downloadUrl"></video>
        <button (click)="uploadVideo()">Upload Video</button>
    </ng-container>
    <br>
    
  </div>
